import { takeLeading } from "redux-saga/effects";
import { actionTypes } from "../actions";
import { fetchTravelWalletCreditHistorySaga } from "./travel-wallet-credit-history";
import { fetchTravelWalletDetailsSaga } from "./travel-wallet-details";

export function* watchFetchTravelWalletDetails() {
  yield takeLeading(
    actionTypes.FETCH_TRAVEL_WALLET_DETAILS,
    fetchTravelWalletDetailsSaga
  );
}

export function* watchFetchTravelWalletCreditHistory() {
  yield takeLeading(
    actionTypes.FETCH_TRAVEL_WALLET_CREDIT_HISTORY,
    fetchTravelWalletCreditHistorySaga
  );
}
